// Import the Bootstrap framework.
// @link https://getbootstrap.com/docs/5.3/getting-started/vite/
import * as bootstrap from 'bootstrap';
import {Fancybox} from '@fancyapps/ui';


Fancybox.defaults.l10n = {
  CLOSE: 'Sluiten',
  NEXT: 'Volgende',
  PREV: 'Vorige',
  MODAL: 'Je kan deze modal sluiten met de ESC toets',
  ERROR: 'De gevraagde gegevens konden niet worden geladen. <br/> Probeer het later opnieuw.',
  IMAGE_ERROR: 'Afbeelding niet gevonden',
  TOGGLE_THUMBS: 'Miniaturen',
  TOGGLE_SLIDESHOW: 'Automatisch afspelen',
  TOGGLE_FULLSCREEN: 'Volledig scherm',
  DOWNLOAD: 'Downloaden',
  SHARE: 'Delen',
  ITERATEZOOM: 'Vergroten',
};

Fancybox.bind('[data-fancybox]', {});

document.documentElement.scrollLeft = 0;


/**
 * Add hover support to the Bootstrap navigation dropdowns on desktop viewports.
 */
function enableDropdownOnHover() {
  const mainNavigation = document.getElementById('primary-menu');
  const dropdowns = mainNavigation.querySelectorAll(".dropdown");
  function handleDropdownHover() {
    const isDesktop = window.matchMedia("(min-width: 1200px)").matches;

    dropdowns.forEach((dropdown) => {
      const dropdownToggle = dropdown.querySelector(".dropdown-toggle");
      if (!dropdownToggle) {
        return;
      }
      const dropdownInstance = new bootstrap.Dropdown(dropdownToggle);

      const mouseenterListener = (event) => {
        dropdownInstance.show();
      };
      const mouseleaveListener = (event) => {
        dropdownInstance.hide();
      };

      if (isDesktop) {
        dropdown.addEventListener("mouseenter", mouseenterListener);
        dropdown.addEventListener("mouseleave", mouseleaveListener);
      } else {
        dropdown.removeEventListener("mouseenter", mouseenterListener);
        dropdown.removeEventListener("mouseleave", mouseleaveListener);
      }
    });
  }

  handleDropdownHover();
  window.addEventListener("resize", handleDropdownHover);
}

/**
 * Apply filters on change.
 */
document.querySelectorAll('.views-exposed-form').forEach(form => {
  // Select the parent of the AJAX container, because the AJAX container will be replaced after an AJAX call.
  const parent = form.closest('.views-element-container')?.parentElement || form;
  parent.addEventListener('change', (e) => {
    // Send click event instead of calling submit, because calling submit will not trigger an AJAX submit.
    parent.querySelector('input[type="submit"]')?.dispatchEvent(new Event('click'));
  });
});

// IntersectionObserver
function setupInViewportObservers() {
  const classList = [
    'frontend',
    'figure',
    'section',
    'site-footer-top'
  ];

  const selectorString = classList.map(className => `.${className}`).join(', ');
  const myElements = document.querySelectorAll(selectorString);

  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-in-viewport');
      }
    });
  }, {
    threshold: .1
  });

  myElements.forEach(element => {
    observer.observe(element);
  });
}

// Enable / disable OS share button.
addEventListener('DOMContentLoaded', () => {
  const shareButton = document.querySelector('#share-button');

  if (!shareButton) {
    return;
  }

  const shareData = {
    title: shareButton.dataset.shareTitle,
    url: shareButton.dataset.shareUrl,
  };

  if (!navigator.canShare || !navigator.canShare(shareData)) {
    shareButton.parentElement.remove();
  } else {
    shareButton.addEventListener('click', async () => {
      try {
        await navigator.share(shareData);
      } catch (err) {
        console.log('Error sharing: ', err);
      }
    });

    shareButton.classList.remove('hide');
  }
});

window.addEventListener('error', event => {
  if (event.target instanceof HTMLImageElement) {
    event.target.srcset = '';
    event.target.src = '/themes/iwink_starterkit/images/error-image.svg';
  }
}, true);

document.addEventListener('DOMContentLoaded', function() {
  enableDropdownOnHover();
  setupInViewportObservers();
});

// Add wrapper to table elements to enable responsive styling.
(function(Drupal, once) {
  let captionCounter = 0;

  function update(wrapper) {
    const overflows = wrapper.scrollWidth > wrapper.clientWidth;
    if (overflows) {
      wrapper.setAttribute('tabindex', '0');
      wrapper.setAttribute('role', 'region');
    } else {
      wrapper.removeAttribute('tabindex');
      wrapper.removeAttribute('role');
    }
  }

  const observer = new ResizeObserver(entries => entries.forEach(entry => update(entry.target)));

  Drupal.behaviors.responsiveTables = {
    attach(context) {
      once('responsiveTable', '.block table, table.table', context).forEach(table => {
        const wrapper = document.createElement('div');
        wrapper.className = 'table-responsive';
        table.before(wrapper);
        wrapper.append(table);

        const caption = table.querySelector('caption');
        if (caption) {
          if (!caption.id) {
            caption.id = `table-caption-${++captionCounter}`;
          }
          wrapper.setAttribute('aria-labelledby', caption.id);
        } else {
          wrapper.setAttribute('aria-label', Drupal.t('Tabel, scrollbaar'));
        }

        observer.observe(wrapper);
      });
    }
  }
})(Drupal, once);

// Hide the section edit/delete buttons and 'add block' button for central content blocks in the layout builder.
(function(Drupal, once) {
  Drupal.behaviors.hideSectionButtons = {
    attach(context) {
      once('centralContentLayout', '.layout-central-content', context).forEach(layout => {
        // Hide the section admin buttons/links.
        this.parentElement.querySelectorAll('.layout-builder__link').forEach(link => {
          link.style.display = 'none';
        });

        // Hide the 'Add block' button.
        const addBlock = layout.querySelector('.layout-builder__add-block');
        if (addBlock) {
          addBlock.style.display = 'none';
        }
      });
    }
  }
})(Drupal, once);
